import { render, staticRenderFns } from "./tinymce-editor.vue?vue&type=template&id=10d3667a&"
import script from "./tinymce-editor.vue?vue&type=script&lang=js&"
export * from "./tinymce-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports